import { useTranslation } from "react-i18next"

import Selector from "@/components/form/selector/Selector"
import { LanguageItem, LANGUAGES } from "@/constants/setting"
import Icon from "@/components/icon/Icon"
import { colors } from "@/components/colors"

import "./languages.scss"
import BasicButton from "@/components/button/BasicButton"
import { useState } from "react"
import { createGlobalStore } from "@/stores/global"
import { useUpsertLanguageMutation } from "@/hooks/api/useAccountQuery"

export default function LanguagesPage() {
  const { i18n, t } = useTranslation()
  const setSnackBar = createGlobalStore((state) => state.setSnackBar)
  const { mutateAsync: upsertLanguage } = useUpsertLanguageMutation()

  const [currentLanguage, setCurrentLanguage] = useState(
    LANGUAGES.find((lang) => lang.value === i18n.language) || LANGUAGES[0],
  )

  const handleSave = async () => {
    await upsertLanguage({ language: currentLanguage.value })
    await i18n.changeLanguage(currentLanguage.value)
    setSnackBar({ message: t("messages.successUpdate"), severity: "success", open: true })
  }

  const renderOption = (
    props: React.HTMLAttributes<HTMLLIElement> & { key: string },
    option: LanguageItem,
  ) => {
    const { key, ...prop } = props

    return (
      <li key={key} {...prop}>
        <div className="language-option-container">
          <div className="language-text-container">
            <div>{option.text}</div>
            <div className="language-label">{option.textEng}</div>
          </div>
          {currentLanguage.value === option.value && (
            <Icon type="check" size={20} color={colors.neutral.grey[1000]} />
          )}
        </div>
      </li>
    )
  }

  return (
    <div className="settings-page-container-gap-40">
      <h3 className="settings-section-title">{t("languages")}</h3>
      <div className="selector-container">
        <div className="selector-row">
          <div className="selector-label">{t("languages")}</div>
          <Selector
            options={LANGUAGES}
            value={currentLanguage}
            renderOption={renderOption}
            labelKey="text"
            onChange={(_: unknown, option: LanguageItem) => {
              if (option) {
                setCurrentLanguage(option)
              }
            }}
          />
        </div>
      </div>
      <div className="settings-button-container">
        <BasicButton
          type="primary-contained"
          size="lg"
          onClick={handleSave}
          disabled={currentLanguage.value === i18n.language}>
          {t("button.save")}
        </BasicButton>
      </div>
    </div>
  )
}
